import { handleActions } from 'redux-actions';
import { Map, fromJS } from 'immutable';

import actions from '../actions';

//REDUCERS
export default handleActions(
  {
    [actions.giftVoucher.get.toString()]: (giftVoucher, { payload }) => {
      return fromJS(payload);
    }
  },
  Map()
);
